import PartnerForm from "../component/PartnerForm";
const AddNewPartner = () => { return (<PartnerForm />) }
export default AddNewPartner;